<template>
    <div v-if="block.display" 
        class="home-block"
        :class="{'is-safari-desktop' : isSafariDesktop}"
        @mousemove="triggerDetection" 
        v-observe-visibility="{
            callback: visibilityChanged,
            intersection:{
                rootMargin: `${block.observeMargin}px 0px ${block.observeMargin}px 0px`
            }
        }" :id="block.elementId">
        <h2 v-if="block.title !== null" v-html="!isLoading ? block.title : '&nbsp;'"></h2>
        <span class="block-subtitle" v-if="block.subTitle" v-html="block.subTitle"></span>
        <div class="home-block-content w-100" :style="{height: `${blockHeight}px`}" >
            <div v-show="backShow" class="block-back" @click="back()" :style="btnNextBackStyles">
                <span class="ecom-chevron-left"></span>
            </div>
            <div v-show="inViewPort" class="home-products-scroll" @scroll="scrollEvent" ref="block" dir="ltr" :style="{scrollPaddingLeft: snapAlign === 'start' ? '3vw' : null}">
                <div class="block-content" :style="{height: `${blockHeight}px`}" @scroll="scrollEvent">
                    <div class="block-snaps" ref="snaps" v-if="!isLoading && !isDiamond">
                        <div v-for="n in block.snaps" class="block-snap" :class="{'block-snap-last': n == block.snaps}" :key="n" :style="{width: n == block.snaps ? `${widthLastSnap}px` : `${(blockWidth * roundNumberProducts)}px`,marginLeft: n == 1 ? `calc(var(--vw, 1vw) * ${margin})` : null, scrollSnapAlign: n == block.snaps ? 'end' : snapAlign }">&nbsp;</div>
                    </div>
                    <div class="blocks" :style="isIE ? {width: `${viewWidth * block.snaps}px`} : {}">
                        <div class="slider-margin" :style="{width: `calc(var(--vw, 1vw) * ${margin})`}">&nbsp;</div> 
                        <template v-if="isLoading">
                            <div class="slider-itens">
                                <div v-for="n in roundNumberProducts" class="slider-item" :key="n" :style="{width: `${blockWidth}px`,height: `${blockHeight}px`}">
                                    <div class="slider-item-content skeleton-box"></div>
                                </div>
                            </div>
                        </template> 
                        <div v-for="n in block.snaps" class="slider-itens" :key="n">
                            <div v-for="(blockItem,index) in block.matrix[n]" :key="blockItem.key" class="slider-item" :style="{width: !blockItem.widthRate ? `${blockWidth}px` : `${(blockWidth * blockItem.widthRate)}px`}">
                                <DiamondText v-if="blockItem.id == 'text'" :content="blockItem" :blockWidth="blockWidth" />
                                <DiamondHtml v-else-if="blockItem.id == 'html'" :content="blockItem" :blockWidth="blockWidth" />
                                <DiamondInfo v-else-if="blockItem.id == 'info'" :content="blockItem" :blockWidth="blockWidth" />
                                <div v-else-if="blockItem.type == 'advantage'" class="slider-item-content" :data-url="block.advantages.url ? block.advantages.url : ''" :style="`border-width: ${borderWidth}px;`" @click.ctrl="() => {return true;}" @click.exact="gotoUrl(block.advantages ? block.advantages.url : '')" :data-width-rate="blockItem.widthRate ? blockItem.widthRate : null" ref="blockItem">
                                    <BlockImage :classNames="'w-100 h-100'" :classNamesBox="'w-100 h-100'" :isScrolled="isScrolled" :image="blockItem.image" :webpAllowed="false" :width="blockWidth" :height="blockHeight" :title="'Prozis'"></BlockImage>
                                    <div v-if="block.isHoverandZoomActivated" class="shadow-bottom-row"/>
                                </div>
                                <keep-alive v-else>
                                    <block-item :fn-goto-url="gotoUrl" :numeration="numeration" :item="blockItem" :borderWidth="borderWidth" :width="blockWidth" :height="blockHeight" :isDesktop="true" :type="block.type" :inViewPort="inViewPort" ref="blockItem" :position="index" :snap="n" :is-hoverand-zoom-activated="block.isHoverandZoomActivated"></block-item>
                                </keep-alive>
                            </div>
                            <Mub v-if="block.hasDiscovery && block.length <= (n * roundNumberProducts)" :rawData="block.mubDataViewMore" >
                                <div class="slider-item" :style="{width: `${viewMoreBlockWidth}px`}" @click="gotoUrl(block.discovery.url)">
                                    <div class="slider-item-content slider-box-view-more">
                                        <div class="w-100 text-center">{{block.discovery.title}}</div>
                                        <div><a class="discovery" :href="block.discovery.url">{{block.discovery.label}}</a></div>
                                    </div>
                                </div>    
                            </Mub>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="nextShow" class="block-next" @click="forward()" :style="btnNextBackStyles">
                <span class="ecom-chevron-right"></span>
            </div>
        </div>
        <div v-show="showDetails" ref="details" class="slider-item-content slider-item-content-details" 
            :class="{'slider-item-content-details-scale': detailsScale, 'slider-item-content-details-left': classLeft, 'slider-item-content-details-right': classRight,'slider-item-content-details-scale-vertical': detailsScale && heightRate>1.5,'slider-item-content-details-scale-four': detailsScale && block.numberItens==4}" 
            @mouseleave="detailsDisabled" 
            @click.ctrl="() => {return true;}"
            @click.exact="detailsClick"
            :style="detailsStyle" >
        </div> 
    </div>
</template>
<script>
//import LoadImage from '@/components/ProductPage/Desktop/LoadImage';
import BlockItem from '../Partials/BlockItem';
import BlockImage from '../../Common/Partials/BlockImage';
import BlockShadow from '../../Common/Partials/BlockShadow';
import BlockShadowDesc from '../../Common/Partials/BlockShadowDesc';
import BlockLabel from '../Partials/BlockLabel';
import DiamondText from '@/components/DiamondModal/DiamondText';
import DiamondHtml from '@/components/DiamondModal/DiamondHtml';
import DiamondInfo from '@/components/DiamondModal/DiamondInfo';
import BlockLikes from '../../Common/Partials/BlockLikes';

import HomeBlock from '@/models/home-block';
import browser from '@/Utilities/browser';
import homeUtils from '@/Utilities/homeUtils';
import timer from '@/Utilities/timer';
import operatingSystem from '@/Utilities/operating-system';
import Mub from '@/components/Mub';

export default {
    components:{
        BlockImage,
        BlockShadow,
        BlockShadowDesc,
        BlockLabel,
        DiamondText,
        DiamondHtml,
        DiamondInfo,
        BlockLikes,
        BlockItem,
        Mub,
    },
    props:{
        block:{
            type: HomeBlock
        },
        heightRate:{
            type: Number,
            default: 1
        },
        widthRate:{
            type: Number,
            default: 1
        },
        snapAlign:{
            type: String,
            default: 'center'
        },
        numeration:{
            type: Boolean,
            default: false
        },
        margin:{
            type: Number,
            default: 3
        },
        borderWidth:{
            type: Number,
            default: 2
        },
        relativeViewport: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            selectedEle: null,
            oldSelectedEle: null,
            blockHeight: 0,
            blockWidth: 0,
            viewMoreBlockWidth: 0,
            backShow: false,
            nextShow: false,
            showDetails: false,
            classLeft: false,
            classRight: false,
            detailsStyle: {},
            detailsTimer: null,
            scrollTimer: null,
            detectItemTimer: null,
            counterTimer: null,
            detailsScale: false,
            detailsContent: '',
            viewWidth: 0,
            inViewPort: false,
            isScrolled: false,
            selectedItem: null
        }
    },
    mounted() {
        this.calcSize();
        this.$nextTick(() => {
            if (this.relativeViewport) {
                setTimeout(() => {
                    this.calcSize();
                }, 300);
            }
        });
        
    },
    updated(){
        const elem = this.$refs.block;
        if(elem && elem.scrollLeft == 0 && this.inViewPort){
            this.nextShow = this.block.length > this.block.numberItens;
        }
    },
    created() {
        window.addEventListener("resize", this.calcSize);
        window.addEventListener("scroll", this.windowScroll);

        // if(this.isDiamond){
        //     console.log('block.snaps', this.block.snaps);
        //     console.log('block matrix', this.block.matrix);
        // }
    },
    destroyed() {
        window.removeEventListener("resize", this.calcSize);
        window.removeEventListener("scroll", this.windowScroll);
    },
    watch: {
        showDetails(newValue){
            let rect = this.selectedEle.getBoundingClientRect();
            let elementWidthRate   = this.selectedEle.dataset?.widthRate ?? null;
            let hasCustomWidthRate = elementWidthRate && (elementWidthRate != this.widthRate);
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            let scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
            /*this.detailsStyle ={
                top: !this.relativeViewport ? `${rect.top + scrollTop - this.borderWidth}px` : `${rect.top + scrollTop - this.borderWidth - 120}px`,
                left: `${rect.left + scrollLeft - this.borderWidth}px`,
                width: `${(this.blockWidth * (!hasCustomWidthRate ? 1 : elementWidthRate)) + (this.borderWidth * 2)}px`,
                height: `${this.blockHeight + (this.borderWidth * 2)}px`
            };*/
            this.detailsStyle ={
                top: !this.relativeViewport ? `${rect.top + scrollTop}px` : `${rect.top + scrollTop - 120}px`,
                left: `${rect.left + scrollLeft}px`,
                width: `${(this.blockWidth * (!hasCustomWidthRate ? 1 : elementWidthRate))}px`,
                height: `${this.blockHeight}px`
            };
            if(newValue){
                //if open before last element close
                if(this.$refs.details.innerHTML != '' && this.oldSelectedEle && this.oldSelectedEle.innerHTML == ''){
                    this.moveChildren(this.$refs.details,this.oldSelectedEle);
                }
                //move the content os selected element to the DOM zoom
                this.$refs.details.innerHTML = '';
                this.moveChildren(this.selectedEle,this.$refs.details);
                this.oldSelectedEle = this.selectedEle;
            }else{
                //relocate the content from zoom to selected element 
                if(this.selectedEle.innerHTML == ''){
                    this.moveChildren(this.$refs.details,this.selectedEle);
                }else if(this.oldSelectedEle && this.oldSelectedEle.innerHTML == ''){
                    this.moveChildren(this.$refs.details,this.oldSelectedEle);
                }
            }
            setTimeout(() => {
                this.detailsScale = newValue
                if(newValue){
                    this.detailsTimerCounter();
                }
            }, 10);
        },
        isLoading(newValue, oldValue){
            if(!newValue && oldValue){
                const elem = this.$refs.block;
                if(elem){
                    elem.scrollTo(0,0);
                }
            }
        }
    },
    computed: {
        widthLastSnap(){
            let numberBlocksRemaining = this.block.length - (Math.floor(this.block.length / this.roundNumberProducts) * this.roundNumberProducts);
            if(numberBlocksRemaining <= 0){
                numberBlocksRemaining = this.roundNumberProducts;
            }
            
            let result = (numberBlocksRemaining * this.blockWidth) + (this.viewWidth * (this.margin / 100));
            if(this.block.hasDiscovery && this.widthRate > 1){
                result = result - (this.blockWidth * ( 1 - ( 1 / this.widthRate )));
            }
            
            return result;
        },
        isIE(){
            return browser.isIE();
        },
        isSafariDesktop() {
            return operatingSystem.isMacOS() && browser.isSafari();
        },
        isLoading(){
            return this.block && this.block.isLoading;
        },
        roundNumberProducts(){
            return Math.floor(this.block.numberItens);
        },
      /*  hasBannerBlock() {
            return this.block.advantages && (this.block.advantageWidthRate && this.block.advantageWidthRate > 1);
        }*/
        isDiamond(){
            return this.block.diamond ? true : false;
        },
        btnNextBackStyles(){
            const bgColor = this.isDiamond ? this.block.diamond.bgColorAlpha : null;
            return bgColor ? {backgroundColor: bgColor} : null;
        }
    },
    methods: {
        visibilityChanged(isVisible){
            this.inViewPort = isVisible;
            if(isVisible){
                this.block.load();
            }
        },
        moveChildren(origin, destination){
            for (const child of origin.children) {
                destination.append(child);
            }
        },
        gotoUrl(url){
            homeUtils.gotoUrl(url,this.block);
        },
        detailsTimerCounter(){
            let details = this.$refs.details;
            if(details && this.showDetails){
                let timerLabel = details.querySelector('.label-timer');
                if(timerLabel){
                    let time   = timerLabel.dataset.timer ? parseInt(timerLabel.dataset.timer) : 0;
                    this.timerCounter(timerLabel,time);
                }
            }
        },
        timerCounter(label,time){
            let structTime = timer.calcTimerCounter(time);
            if(structTime){
                let txt    = timer.formatNumberCounter(structTime.hours) + ':' + timer.formatNumberCounter(structTime.mins) + ':' + timer.formatNumberCounter(structTime.secs);
                label.innerHTML = txt;
                this.counterTimer  = setTimeout(() => { this.timerCounter(label,time) }, 1000);
            }
        },
        scrollEvent(){
            this.detailsDisabled();
            const elem      = this.$refs.block;
            const eSnaps    = this.$refs.snaps;
            if(elem && eSnaps){
                this.isScrolled = true;
                const wWidth    = homeUtils.getViewPortWidth();
                this.nextShow   = eSnaps.offsetWidth > elem.scrollLeft + wWidth + (this.margin / 100 * wWidth);
                this.backShow   = elem.scrollLeft > wWidth * this.margin / 100;
                if(this.inViewPort){
                    this.scrollTimer = setTimeout(() => { this.endBlockScroll() },300);
                }
            }
        },
        endBlockScroll(){
            this.triggerDetection();
        },
        windowScroll(){
            this.detailsDisabled();
            if(this.inViewPort){
                this.scrollTimer = setTimeout(() => { this.triggerDetection() },100);
            }
        },
        triggerDetection(){
            if(this.detailsScale || !this.inViewPort || !this.block.isHoverandZoomActivated){
                return;
            }
            this.detailsDisabled();
            if(this.inViewPort){
                this.detectItemTimer = setTimeout(() => { this.detectItemOver() },100);
            }
        },
        detectItemOver(){
            if(this.detailsScale || !this.inViewPort){
                return;
            }

            //is not the best solution, but is the only possible
            if(this.$refs.blockItem){
                this.$refs.blockItem.forEach(ele => {
                    let l = ele && ele.$el ? ele.$el.querySelector('.shadow-bottom-row') : null;
                    if(l){
                        let c = window.getComputedStyle(l, '::before').getPropertyValue('content');
                        if(c == '" "'){
                            this.itemZoom(ele.$el);
                            return;
                        }
                    }
                });
            }
        },
        back(){
            const wWidth   = homeUtils.getViewPortWidth();
            const elem     = this.$refs.block;
            const margin   = (this.margin / 100 * wWidth);
            //const widthCrt = (this.blockWidth * this.roundNumberProducts) + this.widthLastSnap;
            //const lastScr  = widthCrt > wWidth ? (widthCrt - wWidth + margin) : widthCrt;
            const left     = this.nextShow ? this.blockWidth * this.roundNumberProducts : (this.widthLastSnap / 2);
            const value    = left > 0 ? -left : 0;
            this.smoothScrolling(elem,value);
        },
        forward(){
            const elem  = this.$refs.block;
            const value = this.blockWidth * this.roundNumberProducts;
            this.smoothScrolling(elem,value);
        },
        smoothScrolling(e,value){
            e.scrollBy({
                top: 0, 
                left: value,
                behavior: 'smooth'
            });
        },
        detailsClick(){
            if (this.selectedEle.hasAttribute("data-url")) {
                this.gotoUrl(this.selectedEle.dataset.url);
            }
        },
        itemZoom(element){
            while(!element.getAttribute('class').includes('slider-item-content')){
                element = element.parentElement;
            }
            if(!element){
                return;
            }
            this.selectedEle     = element;
            let elementWidthRate = this.selectedEle.dataset?.widthRate ?? null;
            let rect = this.selectedEle.getBoundingClientRect();
            let elemBlk      = this.$refs.block;
            let marginLeft   = elemBlk ? elemBlk.getBoundingClientRect().left : 0;
            let detailsLeft  = (rect.left - marginLeft) < this.blockWidth;
            let detailsRight = (rect.left - marginLeft) > (this.blockWidth + this.borderWidth) * (this.block.numberItens - 1);
            if(elementWidthRate && (elementWidthRate != this.widthRate)) {
                detailsLeft  = (rect.left - marginLeft) < this.blockWidth * elementWidthRate;
                detailsRight = (rect.left - marginLeft) > ((this.blockWidth * elementWidthRate) + this.borderWidth) * (this.block.numberItens - 1);
            }
            //let wrap = document.createElement('div');
            //wrap.appendChild(element.cloneNode(true));
            if(!this.selectedEle.hasAttribute("data-position")){
                return;
            }
            this.detailsScale   = false;
            this.detailsTimer   = setTimeout(() => {
                //this.detailsContent = element.innerHTML;
                this.classLeft      = detailsLeft;
                this.classRight     = detailsRight;
                this.showDetails    = true;
            }, 50);
        },
        getVideoTime(element){
            let video = element.querySelector("video");
            if(video){
                return video.currentTime;
            }
            return null;
        },
        detailsDisabled(){
            clearTimeout(this.detailsTimer);
            clearTimeout(this.scrollTimer);
            clearTimeout(this.detectItemTimer);
            clearTimeout(this.counterTimer);
            this.detailsScale = false;
            setTimeout(() => {
                this.showDetails  = false;
                this.selectedItem = null;
            }, 150);
        },
        calcSize(){
            this.viewWidth          = homeUtils.getViewPortWidth();
            let marWidth            = Math.round(this.viewWidth * (this.margin * 2 / 100));
            let proWidth            = (this.viewWidth - marWidth) / this.block.numberItens;
            this.blockWidth         = Math.round(proWidth);
            this.blockHeight        = (this.blockWidth / this.widthRate ) * this.heightRate;
            this.viewMoreBlockWidth = this.blockWidth / this.widthRate;
        },
    }
}
</script>
